import React from 'react';
import Download from 'src/assets/images/iconsMvpApp/Download icon.svg';
import { t } from 'i18next';

export const DownloadIcon = () => {
  return (
    <img
      src={Download}
      alt={t('Download')}
      style={{
        width: '24px',
        height: '24px',
      }}
    />
  );
};
